import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { State, PaymentGatewayService } from '../services';

export const paymentGateway = (paymentGatewayService: PaymentGatewayService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.paymentGateway !== undefined) {
        const { saveToQ, providerAction, additionalValues } =
          state.system.paymentGateway;
        const campaignId = state.action?.campaignId;
        return paymentGatewayService
          .showModal$(providerAction, campaignId, additionalValues)
          .pipe(
            map((data) => {
              return [
                {
                  ...state,
                  ...{
                    system: {
                      ...state.system,
                      ...{
                        paymentGateway: undefined,
                      },
                    },
                  },
                  answers: [
                    ...state.answers!.slice(0, saveToQ),
                    data,
                    ...state.answers!.slice(saveToQ + 1),
                  ],
                },
                currentState,
              ];
            })
          );
      }
      return of([state, currentState] as [Partial<State>, State]);
    })
  );
